import type { ReactNode } from "react";
import { cn } from "../lib/utils";

type PageHeaderProps = {
	title: string;
	description?: ReactNode;
	/** Secondary actions. The primary action belongs at the bottom on phones. */
	actions?: ReactNode;
	className?: string;
};

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
	return (
		<header
			data-slot="page-header"
			className={cn("flex flex-wrap items-start justify-between gap-3 pb-4", className)}
		>
			<div className="min-w-0">
				<h1 className="text-xl font-semibold tracking-tight md:text-2xl">{title}</h1>
				{description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
			</div>
			{actions ? (
				<div className="flex max-w-full min-w-0 flex-wrap items-center gap-2">{actions}</div>
			) : null}
		</header>
	);
}
